import React, { Component } from "react";
import { Row, Col, Button, Alert } from "reactstrap";
import { Link } from "react-router-dom";
import { MdArrowBack, MdModeEdit, MdAutorenew, MdLens } from "react-icons/md";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { domainActions } from "./actions/domains.actions";

import { Spinner, Placeholder } from "../Shared";
import { routeConstants } from "../../_constants";

export class Domain extends Component {
  componentDidMount() {
    this.getDomain();
  }

  componentWillUnmount() {
    this.props.resetDomain();
  }

  getDomain = () => {
    const { match } = this.props;
    if (match.params && match.params.id) {
      this.props.getDomain(match.params.id);
    }
  };

  render() {
    const { match, response, fetching, error } = this.props;
    const domain = response && response.modelList[0];

    return (
      <div>
        <Row>
          <Col sm="6">
            <Link className="btn btn-outline btn-primary" to={routeConstants.DOMAINS.path}>
              <MdArrowBack /> Back to list
            </Link>
          </Col>
          <Col sm="6">
            <div className="text-right">
              <h5 className="item-count">
                <div>
                  Domain: {domain && domain.code}{" "}
                  <Button
                    onClick={this.getDomain}
                    color="primary"
                    outline
                    disabled={fetching}
                  >
                    {fetching ? (
                      <Spinner />
                    ) : (
                      <div>
                        <MdAutorenew size={20} />
                      </div>
                    )}
                  </Button>
                </div>
              </h5>
            </div>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col>
            {error && (
              <Alert color="danger">
                <strong>Error:</strong> {error.message}
              </Alert>
            )}

            <dl className="row">
              {/* <dt className="col-sm-3">Domain</dt>
              <dd className="col-sm-9">
                {domain ? (
                  domain.id
                ) : (
                  <Placeholder text="Fetching data" blur={3} />
                )}
              </dd> */}

              <dt className="col-sm-3">Domain Code</dt>
              <dd className="col-sm-9">
                {domain ? (
                  domain.code
                ) : (
                  <Placeholder text="Fetching data" blur={3} />
                )}
              </dd>

              <dt className="col-sm-3">Domain Description</dt>
              <dd className="col-sm-9">
                {domain ? (
                  domain.description
                ) : (
                  <Placeholder text="Fetching data" blur={3} />
                )}
              </dd>
              
              <dt className="col-sm-3">Domain Status</dt>
              <dd className="col-sm-9">
                {domain ? (
                  domain.enabled ?
                    <span>
                      <MdLens className="text-success" /> Enabled
                    </span>
                   : 
                    <span>
                      <MdLens className="text-danger" /> Disabled
                    </span>
                  
                ) : (
                  <Placeholder text="Fetching data" blur={3} />
                )}
              </dd>
            </dl>
            <Link
              className="btn btn-primary"
              to={`${routeConstants.DOMAINS.path}/edit/${match.params.id}`}
            >
              <MdModeEdit /> Edit
            </Link>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { fetching, fetched, request, response, error } = state.viewDomain;
  return {
    fetching,
    fetched,
    request,
    response,
    error
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getDomain: bindActionCreators(
      domainActions.getDomain,
      dispatch
    ),
    resetDomain: bindActionCreators(
      domainActions.resetDomain,
      dispatch
    )
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Domain);
